import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import {
  fetchFeedbackList,
  removeFeedback,
} from "src/services/feedback.service";

interface FetchFeedbackList {
  page: number;
  limit: number;
  search?: string;
}

export const doFetchFeedbackList = createAsyncThunk(
  "feedback/fetchFeedbackList",
  async (payload: FetchFeedbackList) => {
    try {
      const response: any = await fetchFeedbackList({
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch feedback list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

export const doRemoveFeedback = createAsyncThunk(
  "feedback/removeFeedback",
  async (fid: string) => {
    try {
      const response: any = await removeFeedback(fid);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to remove feedback";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);
